export type ResolverEvent = {
  resolver: string;
  location: string;
  status: "ok" | "nxdomain" | "timeout" | "error" | "servfail";
  records?: string[];
  latencyMs?: number;
  message?: string;
  /**
   * DNS AD bit: this resolver asserts it DNSSEC-validated the answer.
   * `false` is ambiguous (unsigned zone OR non-validating resolver) and
   * `undefined` means the resolver didn't report — only `true` proves anything.
   */
  ad?: boolean;
};

export type DnssecSummary = {
  /** Resolvers that asserted validation (AD=1). */
  validated: number;
  /** Resolvers that reported the AD bit at all — the honest denominator. */
  reported: number;
  /** Resolvers that returned SERVFAIL. */
  servfail: number;
};

export type DoneEvent = {
  done: true;
  consensus: Record<string, number>;
  dnssec?: DnssecSummary;
};

export function streamLookup(
  host: string,
  type: string,
  onEvent: (e: ResolverEvent) => void,
  onDone: (e: DoneEvent) => void,
  onError: (msg: string) => void,
): () => void {
  const url = `/api/lookup?host=${encodeURIComponent(host)}&type=${encodeURIComponent(type)}`;
  const es = new EventSource(url);
  es.onmessage = (msg) => {
    try {
      const data = JSON.parse(msg.data);
      if (data.done) {
        onDone(data);
        es.close();
      } else {
        onEvent(data);
      }
    } catch {
      // ignore malformed
    }
  };
  es.onerror = () => {
    onError("Connection lost");
    es.close();
  };
  return () => es.close();
}
